import {useMutation} from '@tanstack/react-query';
import {apiClient, queryClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {toast} from '@common/ui/toast/toast';
import {message} from '@common/i18n/message';
import {showHttpErrorToast} from '@common/utils/http/show-http-error-toast';
import { DatatableDataQueryKey } from '@common/datatable/requests/paginated-resources';
import { FileItem } from '@app_modules/loan-applications/step1/file-item';

interface Response extends BackendResponse {}

interface Payload {
  id: number,
  market_rate_date: string;
  loan_program_type: string;
  investor_code: string;
  sheet_name: string;
  description: string;
  analysis_prompt: string;
}

export function useAnalyzeAction(id: number, market_rate_date: string, loan_program_type: string, investor_code: string, sheet_name: string, description: string, analysis_prompt: string) {
  return useMutation({
    mutationFn: ({id, market_rate_date, loan_program_type, investor_code, description, analysis_prompt}: Payload) =>
      executeAnalyzeAction({id: id, market_rate_date: market_rate_date, loan_program_type: loan_program_type, investor_code: investor_code, sheet_name: sheet_name, description: description, analysis_prompt: analysis_prompt}),
      onSuccess: (response: any, payload) => {
      if (response.message) {
        toast(
          message(response.message),
        );
      } else {
        toast(
          message(`You has just executed check ${investor_code}.`),
        );
      }
      
      //queryClient.invalidateQueries({queryKey: DatatableDataQueryKey(`market-rates/${market_rate_date}`)});
    },
    onError: err => showHttpErrorToast(err),
  });
}

function executeAnalyzeAction({
  id, market_rate_date, loan_program_type, investor_code, sheet_name, description, analysis_prompt
}: Payload): Promise<Response> {
  return apiClient
    .post(`market-rates/${id}/execute-analyze-action`, {loan_program_type: loan_program_type, investor_code: investor_code, sheet_name: sheet_name, description: description, analysis_prompt: analysis_prompt})
    .then(r => r.data);
}


